import { render, staticRenderFns } from "./AddMainVideo.vue?vue&type=template&id=d39b44f6&"
import script from "./AddMainVideo.vue?vue&type=script&lang=ts&"
export * from "./AddMainVideo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports